import { apiRecipientWarning } from '@/request/api';
import { ref } from 'vue';

export default () => {
    const loading = ref(false)

    async function changeWarning(row, emailWarning) {
        if (loading.value) return;
        loading.value = true;
        try {
            const { code } = await apiRecipientWarning({ recipientId: row.id, emailWarning });
            if (code !== '0') return;
            row.emailWarning = emailWarning;
        } finally {
            loading.value = false;
        }
    }

    return { changeWarning }
}